export default {
    updateSettings(state, payload) {
        // TODO: Consider doing an Object.assign() here
        state.approval_flows = [{id: '0', name: 'No Approval Required'}, ...payload.approval_flows];
        state.cost_splits = payload.cost_splits;
        state.social_media_networks = payload.social_media_networks;
        state.allowed_networks = payload.allowed_networks;
        state.show_social_media_settings = payload.show_social_media_settings;
        state.post_message = payload.post_message;
        state.post_message_length = payload.post_message_length;
        state.groups = payload.groups;
        state.team_connection_access = payload.team_connection_access;
        state.template_print_settings = payload.template_print_settings;
        state.auto_pay_available = payload.auto_pay_available;
        state.social_website_fields = payload.social_website_fields;
        state.preview_image_url = payload.preview_image_url;
        state.twitter_url_length = payload.twitter_url_length;
        state.user_types = payload.user_types;
        state.allowed_comarketer_user_types = payload.allowed_comarketer_user_types;
        state.show_organization_select = payload.show_organization_select;
        state.show_template_select = payload.show_template_select;
        state.organizations = payload.organizations;
        state.force_redirect = payload.force_redirect;
        state.has_media_template_permission = payload.has_media_template_permission;
        state.auto_pay_org_share = payload.auto_pay_org_share;
        state.expires_in_days_options = payload.expires_in_days_options;
    },

    updateApprovalFlows(state, payload) {
        state.approval_flows = payload.approval_flows;
    },

    updateTemplates(state, payload) {
        state.templates = payload;
    },

    updateIsLoadingMediaForm(state, payload) {
        state.isLoadingMediaForm = payload;
    },
}